import gql from 'graphql-tag';
import Address from './Address';

export default gql`
	fragment CremationManagerAddressBook on CremationManagerAddressBook {
		ID
        Name
        Contact
        Email
        Phone
        Fax
        Mobile
        AddressLine1
        AddressLine2
        State
        Suburb
        Postcode
        AddressBookCategory
        Religion
        Notes
        NotCurrent
        RegistrationNoMisc
        NotifyBeforeInsertion
        CollectionNote
        DeliveryAddresses {
            ...Address
        }
        PickupAddress {
            ...Address
        }
        LeadSource {
            ID
            SourceType
            SourceName
        }
	}
    ${Address}
`;
